import ApiService from "./ApiService"

export async function apiGetSiteLogos() {
  return ApiService.fetchData({
    url: '/settings/logos',
    method: 'get',
  })
}

export async function apiUpdateSiteLogo(slot, formData) {
  return ApiService.fetchData({
    url: '/settings/logos/' + slot,
    method: 'post',
    data: formData,
  })
}

export async function apiGetSiteName() {
  return ApiService.fetchData({
    url: '/settings/site-name',
    method: 'get',
  })
}

export async function apiUpdateSiteName(name) {
  return ApiService.fetchData({
    url: '/settings/site-name',
    method: 'post',
    data: { name },
  })
}

export async function apiGetAnnouncement() {
  return ApiService.fetchData({
    url: '/settings/announcement',
    method: 'get',
  })
}

export async function apiUpdateAnnouncement(announcement) {
  return ApiService.fetchData({
    url: '/settings/announcement',
    method: 'post',
    data: { announcement },
  })
}

export async function apiGetEmailRecoverySettings() {
  return ApiService.fetchData({
    url: '/settings/email-recovery',
    method: 'get',
  })
}

export async function apiUpdateEmailRecoverySettings(data) {
  return ApiService.fetchData({
    url: '/settings/email-recovery',
    method: 'post',
    data,
  })
}

export async function apiGetTelegramSettings() {
  return ApiService.fetchData({
    url: '/settings/telegram',
    method: 'get',
  })
}

export async function apiUpdateTelegramSettings(data) {
  return ApiService.fetchData({
    url: '/settings/telegram',
    method: 'post',
    data,
  })
}

export async function apiSendTelegramTest() {
  return ApiService.fetchData({
    url: '/settings/telegram/test',
    method: 'post',
  })
}

export async function apiGetTradersByCountry() {
  return ApiService.fetchData({
    url: '/settings/traders-by-country',
    method: 'get',
  })
}

export async function apiUpdateTradersByCountry(counts) {
  return ApiService.fetchData({
    url: '/settings/traders-by-country',
    method: 'post',
    data: { counts },
  })
}

export async function apiGetIncentiveImages() {
  return ApiService.fetchData({
    url: '/settings/incentive-images',
    method: 'get',
  })
}

export async function apiAddIncentiveImage(formData) {
  return ApiService.fetchData({
    url: '/settings/incentive-images',
    method: 'post',
    data: formData,
  })
}

export async function apiDeleteIncentiveImage(id) {
  return ApiService.fetchData({
    url: '/settings/incentive-images/' + id,
    method: 'delete',
  })
}

export async function apiClearAllData(pin, confirmation) {
  return ApiService.fetchData({
    url: '/settings/clear-all-data',
    method: 'post',
    data: { pin, confirmation },
  })
}

export async function apiGetDepositAddress() {
  return ApiService.fetchData({
    url: '/settings/deposit-address',
    method: 'get',
  })
}

export async function apiUpdateDepositAddress(tronDepositAddress) {
  return ApiService.fetchData({
    url: '/settings/deposit-address',
    method: 'post',
    data: { tron_deposit_address: tronDepositAddress },
  })
}

export async function apiGetContactEmailSettings() {
  return ApiService.fetchData({
    url: '/settings/contact-email',
    method: 'get',
  })
}

export async function apiUpdateContactEmailSettings(contactEmail) {
  return ApiService.fetchData({
    url: '/settings/contact-email',
    method: 'post',
    data: { contact_email: contactEmail },
  })
}

export async function apiSendContactMessage(data) {
  return ApiService.fetchData({
    url: '/contact',
    method: 'post',
    data,
  })
}

export async function apiGetPaycoinectSettings() {
  return ApiService.fetchData({
    url: '/settings/paycoinect',
    method: 'get',
  })
}

export async function apiUpdatePaycoinectSettings(data) {
  return ApiService.fetchData({
    url: '/settings/paycoinect',
    method: 'post',
    data,
  })
}

export async function apiTestPaycoinect() {
  return ApiService.fetchData({
    url: '/settings/paycoinect/test',
    method: 'post',
  })
}

/**
 * Whether the Bank/Ewallet rail is switched on (/settingsdb toggle).
 *
 * Its own endpoint because the withdrawal request form needs the answer and
 * sits nowhere near the wallet page — it would otherwise have to pull a whole
 * wallet summary to read one boolean.
 */
export async function apiGetCashoutEnabled() {
  return ApiService.fetchData({
    url: '/settings/cashout-enabled',
    method: 'get',
  })
}

/**
 * Gas fee percent withheld from member withdrawal requests. The read is
 * public so every request dialog can preview the fee. The write is admin-only.
 */
export async function apiGetGasFee() {
  return ApiService.fetchData({
    url: '/settings/gas-fee',
    method: 'get',
  })
}

export async function apiUpdateGasFee(gasFeePct) {
  return ApiService.fetchData({
    url: '/settings/gas-fee',
    method: 'post',
    data: { gas_fee_pct: gasFeePct },
  })
}

/**
 * System fee percent. Stored for future use; nothing charges it yet.
 * The read is public. The write is admin-only.
 */
export async function apiGetSystemFee() {
  return ApiService.fetchData({
    url: '/settings/system-fee',
    method: 'get',
  })
}

export async function apiUpdateSystemFee(systemFeePct) {
  return ApiService.fetchData({
    url: '/settings/system-fee',
    method: 'post',
    data: { system_fee_pct: systemFeePct },
  })
}

/**
 * Daily window (Manila time) for payout withdrawal requests. The read is
 * public for the payouts page. The write is admin-only.
 */
export async function apiGetWithdrawalHours() {
  return ApiService.fetchData({
    url: '/settings/withdrawal-hours',
    method: 'get',
  })
}

export async function apiUpdateWithdrawalHours(start, end) {
  return ApiService.fetchData({
    url: '/settings/withdrawal-hours',
    method: 'post',
    data: { start, end },
  })
}

export async function apiGetFeatures() {
  return ApiService.fetchData({
    url: '/settings/features',
    method: 'get',
  })
}

/** Partial update: any subset of { incentives, announcements, locations, vip }. */
export async function apiUpdateFeatures(features) {
  return ApiService.fetchData({
    url: '/settings/features',
    method: 'post',
    data: features,
  })
}
